import React, { lazy, Suspense, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';

import { Loader } from 'ui';
import { RoundButton } from 'ui/Buttons';

const ViewPeerGroupModal = lazy(() => import('./ViewPeerGroupModal'));

const ViewPeerGroup = ({ id, fetchPeersNames }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <RoundButton label={t('View peer group')} onClick={handleOpen} />
      <Dialog open={isOpen} maxWidth="md" fullWidth>
        <Suspense fallback={<Loader center />}>
          <ViewPeerGroupModal id={id} onClose={handleClose} fetchPeersNames={fetchPeersNames} />
        </Suspense>
      </Dialog>
    </>
  );
};

ViewPeerGroup.propTypes = {
  id: PropTypes.string.isRequired,
  fetchPeersNames: PropTypes.func.isRequired,
};

export default ViewPeerGroup;
